import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const UserVideos = () => {
  const patientVideos = [
    {
      patientVideoId: "1",
      patientVideoLink: "https://www.youtube.com/embed/rZWeIwn20qM?controls=0",
    },
    {
      patientVideoId: "2",
      patientVideoLink: "https://www.youtube.com/embed/DSUxo6IpXJo?controls=0",
    },
    {
      patientVideoId: "3",
      patientVideoLink: "https://www.youtube.com/embed/Edxm16BvaEQ?controls=0",
    },
    {
      patientVideoId: "4",
      patientVideoLink: "https://www.youtube.com/embed/BB50fiMvV9Y?controls=0",
    },
    {
      patientVideoId: "5",
      patientVideoLink: "https://www.youtube.com/embed/MqO6ewP-4uk?controls=0",
    },
    {
      patientVideoId: "6",
      patientVideoLink: "https://www.youtube.com/embed/Dn1kbgGiSvg?controls=0",
    },
    {
      patientVideoId: "7",
      patientVideoLink: "https://www.youtube.com/embed/_ZD9Bh8Im5A?controls=0",
    },
  ];
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    cseEase: "linear",
    lazyLoad: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    swipeToSlide: true,
  };
  return (
    <>
      <div className="container">
        <div className="need-heading">
          <h1 className="text-center text-til my-3">PATIENT STORIES</h1>
        </div>
        <div className="row" data-aos="fade-up">
          <div className="col">
            <Slider {...settings}>
              {patientVideos.map((value, index) => (
                <span className="card p-1 border-0" key={index}>
                  <iframe
                    width="100%"
                    height="100%"
                    src={value.patientVideoLink}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </span>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserVideos;
